import type { ButtonHTMLAttributes, MouseEvent, PropsWithChildren } from 'react';

interface PublicProfileScrollButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  targetId: string;
}

export function PublicProfileScrollButton({
  targetId,
  children,
  onClick,
  ...props
}: PropsWithChildren<PublicProfileScrollButtonProps>) {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) {
      return;
    }

    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }

    const reduceMotion = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };

  return (
    <button type="button" onClick={handleClick} {...props}>
      {children}
    </button>
  );
}
